// extracted by mini-css-extract-plugin
export default {"container":"License_container__BeUyk","header":"License_header__4RQBo","form":"License_form__DoYnh","actions":"License_actions__OOW13"};